import React from 'react';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const DownloadAction = ({ onClick, disabled, name = 'download' }) => (
  <RibbonMenu
    name={name}
    icon="download"
    message={`actions.${name}`}
    onClick={onClick}
    className="aridhia-download-action"
    disabled={disabled}
  />
);

export default DownloadAction;
